import { render, staticRenderFns } from "./DukandarKashf.vue?vue&type=template&id=990f4eb0&"
import script from "./DukandarKashf.vue?vue&type=script&lang=js&"
export * from "./DukandarKashf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports